<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong> {{ $t('authForm.createAccount') }} </strong>
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item :label="$t('authForm.firstName')">
          <a-input
            size="large"
            :placeholder="$t('authForm.firstName')"
            v-decorator="['firstname', {rules: [{ required: true, message: $t('authForm.requiredFirstName') }]}]"
          />
        </a-form-item>
        <a-form-item :label="$t('authForm.lastName')">
          <a-input
            size="large"
            :placeholder="$t('authForm.lastName')"
            v-decorator="['lastname', {rules: [{ required: true, message: $t('authForm.requiredLastName') }]}]"
          />
        </a-form-item>
        <a-form-item label="Email">
          <a-input
            type="email"
            size="large"
            :placeholder="$t('authForm.emailAddress')"
            v-decorator="['email', {rules: [{ required: true, message: $t('authForm.requiredEmail') }]}]"
          />
        </a-form-item>
        <!-- <a-form-item :label="$t('authForm.phoneNumber')">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{
                  required: true,
                  message: $t('authForm.requiredPhoneNumber'),
                  pattern: new RegExp(/[0-9\+]+/g, '')
                }],
              },
            ]"
            :placeholder="$t('authForm.phoneNumber')"
          />
        </a-form-item> -->
        <a-form-item :label="$t('authForm.password')">
          <a-input
            size="large"
            type="password"
            :placeholder="$t('authForm.password')"
            v-decorator="['password', {rules: [{ required: true, min: 8 }]}]"
          />
        </a-form-item>
        <a-form-item :label="$t('authForm.confirmPassword')">
          <a-input
            size="large"
            type="password"
            :placeholder="$t('authForm.confirmPassword')"
            v-decorator="['confirmpassword', {rules: [{ required: true, min: 8 }]}]"
          />
        </a-form-item>
        <div class="d-flex flex-column justify-content-center align-items-center mb-4">
          <vue-recaptcha
            sitekey="6LeO3zwiAAAAAJn7WDRN9CzqkIqflxiYLPb4awa7"
            ref="recaptcha"
            @verify="isCaptchaValid = true"
            @error="isCaptchaValid = false"
            @expired="isCaptchaValid = false"
          />
          <div v-if="showWarningCaptcha" class="validation-message mt-2 p-2">
            Captcha is Required
          </div>
        </div>
        <a-button
          type="primary"
          size="large"
          class="text-center w-100"
          :loading="loading"
          htmlType="submit"
        >
          <strong> {{ $t('authForm.register') }} </strong>
        </a-button>
      </a-form>
      <div>
        <span class="mr-1"> {{ $t('authForm.toc') }} </span>
        <a href="javascript: void(0);" class="kit__utils__link">Terms of Service</a> {{ $t('authForm.and') }}
        <a href="javascript: void(0);" class="kit__utils__link">Privacy Policy</a>
      </div>
      <div class="text-center pt-2 mb-auto">
        <span class="mr-2"> {{ $t('authForm.alreadyHaveAccount') }} </span>
        <router-link to="/auth/login" class="kit__utils__link font-size-16"> {{ $t('authForm.signIn') }} </router-link>
      </div>
      <div>
        <a-modal v-model="modalConfirmation" title="Register Success" :closable="false" @cancel="cancelModal" @ok="cancelModal" :centered="true">
          <div class="row">
            <div class="col-12 d-flex justify-content-center text-center">
              <a-icon type="check-circle" style="color: green; font-size: 100px" />
            </div>
            <div class="col-12 d-flex justify-content-center text-center mt-4">
              <h6> {{ $t('authForm.tankYou') }} </h6>
            </div>
            <div class="col-12 d-flex justify-content-center text-center">
              <p class="text-muted"> {{ $t('authForm.registerSuccess', { email: form.getFieldValue('email') }) }}   </p>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>

import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'CuiRegister',
  components: {
    VueRecaptcha,
  },
  computed: {
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      modalConfirmation: false,
      isCaptchaValid: false,
      showWarningCaptcha: false,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.isCaptchaValid === true) {
        this.form.validateFields((err, values) => {
          if (this.form.getFieldValue('password') !== this.form.getFieldValue('confirmpassword')) {
            return this.$notification.error({
              message: this.$t('authForm.passwrdNotmatch'),
            })
          }

          if (!err) {
            this.$store.dispatch('user/REGISTER', { payload: values })
              .then(data => {
                this.modalConfirmation = true
                this.$notification.success({
                  message: this.$t('authForm.registerSuccess', { email: this.form.getFieldValue('email') }),
                })
                // this.$router.push({ name: 'otp' })
              })
              .catch(err => {
                this.$notification.error({
                  message: this.$t('authForm.registerFailed'),
                  description: err.response?.data?.message || err.message,
                })
              })
          }
        })
      } else {
        this.showWarningCaptcha = true
      }
    },
    cancelModal () {
      this.$router.push('/auth/login')
      this.form.resetFields()
    },
  },
  watch: {
    showWarningCaptcha: {
      immediate: true,
      handler(value) {
        if (value === true) {
          setTimeout(() => {
            this.showWarningCaptcha = false
          }, 3000)
        }
      },
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
<style lang="scss">
.validation-message {
  border: 1px solid transparent;
  color: #842029;
  background-color: #f8d7da;
  border-color: #f5c2c7;
  border-radius: 5px;
  max-width: 450px;
  margin: auto;
}
</style>
